import { get, post, put, del } from '@utilities';
import { AxiosResponse } from 'axios';

export const getUserById = async (userId: string | number): Promise<AxiosResponse> =>
	await get(`user/id/${userId}`);

export const getAllUsers = async (data: Record<string, any>): Promise<AxiosResponse> => await post('user/all', data);
export const updateUserStatus = async (data): Promise<AxiosResponse> => await put('user/update_status', data);
export const addUser = async (data: Record<string, any>): Promise<AxiosResponse> => await post('user', data);
export const fetchDepartments = async (): Promise<AxiosResponse> => await get('/organisation/department');
export const fetchDesignations = async (): Promise<AxiosResponse> => await get('/organisation/designation');
export const addDepartment = async (body: Record<string, any>): Promise<AxiosResponse> => await post('/organisation/department', body);
export const autocompleteManager = async (
	prefix: any,
	department: string,
	designation: string
): Promise<AxiosResponse> =>
	await get(`user/employee?prefix=${prefix}&department=${department}&designation=${designation}`);
export const getAssignedProjects = async (userId: string | number): Promise<AxiosResponse> =>
	await get(`user/${userId}/assigned-projects`);

export const updateEmployeeDetails = async (userId: number, data: any): Promise<AxiosResponse> =>
	await put(`user/${userId}/employee`, data);

export const deleteEmployee = async (
	userId: number | string,
	replacementUserId?: number | string | null
): Promise<AxiosResponse> => {
	const url = replacementUserId
		? `user/${userId}/remove?replacement_user_id=${replacementUserId}`
		: `user/${userId}/remove`;
	return await put(url);
};

export const fetchSchedulerStageMappings = async (): Promise<AxiosResponse> =>
	await get('organisation/scheduler-stage-mapping');

export const fetchSchedulerConfigActivities = async (): Promise<AxiosResponse> =>
	await get('organisation/scheduler-stage-mapping/activities');

export const saveSchedulerStageMapping = async (data: Record<string, unknown>): Promise<AxiosResponse> =>
	await put('organisation/scheduler-stage-mapping', data);

export const deleteSchedulerStageMapping = async (mappingId: number): Promise<AxiosResponse> =>
	await del(`organisation/scheduler-stage-mapping/${mappingId}`);
